import React, {Fragment} from "react";
import PropTypes from "prop-types";
import { RadialBarChart, BarChart as RechartBarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from "recharts";
import { ChartLoader } from "../DataChart";

export default class BarChart extends React.Component {

    static propTypes = {
        // the fieldname used as the base of grouping (the "X axis label")
        base: PropTypes.string,
        // an array containing the dataKeys for the bars
        visibleData: PropTypes.array,
        // an object containing a realHeight (number) for setting the chart Height 
        activeDimensions: PropTypes.object
    }

    render() {

        let chartWidth = 500;
        if (this.props.value?.length > 0) {
            chartWidth = this.props.value.length * (this.props.visibleData.length > 2 ? this.props.visibleData.length : 2) * 30 + 150;
        }

        return this.props.value.length == 0 ? <ChartLoader /> :
            <RechartBarChart 
                width={chartWidth}
                height={this.props.activeDimensions?.realHeight ? this.props.activeDimensions.realHeight - 45 : 260}
                data={this.props.value}>
                <CartesianGrid strokeDasharray="1 2" />
                <XAxis
                    dataKey={this.props.base}
                    interval={0}
                    angle={8}
                    tickMargin={10}
                    // tick={{stroke: 'red', strokeWidth: 2}}
                />
                <YAxis width={70} type="number" />
                <Tooltip 
                    formatter={(value, name, index) => [
                        this.props.columnSettings[name]?.renderer(value) || value,
                        this.props.possibleVisibleColumns.find(col => col.value == name)?.label || name
                    ]}
                />
                <Legend
                    formatter={(value, entry, index) => this.props.possibleVisibleColumns.find(col => col.value == value)?.label || value}
                />
                {this.props.visibleData.map((fieldName, index) => <Bar
                    key={"bar-" + index}
                    dataKey={fieldName}
                    barSize={20}
                    fill={this.props.colors[index] || "#ffffff"}
                />)}
            </RechartBarChart>;
    }
}